import { Controller } from "@hotwired/stimulus";
import "./component.scss";

const applyCountToBadge = (badge, count) => {
  const normalizedCount = Number(count) || 0;

  if (normalizedCount > 0) {
    badge.textContent = normalizedCount > 99 ? "99+" : normalizedCount.toString();
    badge.style.display = "flex";
  } else {
    badge.style.display = "none";
    badge.textContent = "0";
  }
};

export default class extends Controller {
  static targets = ["badge", "chatBadge"];

  connect() {
    this.boundHandleMarkAllAsRead = this.handleMarkAllAsRead.bind(this);
    this.boundHandleUnreadCountUpdated = this.handleUnreadCountUpdated.bind(this);

    document.addEventListener("turbo:submit-end", this.boundHandleMarkAllAsRead);
    document.addEventListener("notifications:unread-count-updated", this.boundHandleUnreadCountUpdated);
  }

  disconnect() {
    document.removeEventListener("turbo:submit-end", this.boundHandleMarkAllAsRead);
    document.removeEventListener("notifications:unread-count-updated", this.boundHandleUnreadCountUpdated);
  }

  handleMarkAllAsRead(event) {
    const formElement = event.detail?.formSubmission?.formElement;
    const isMarkAllRead = formElement?.action?.includes("mark_all_as_read");

    if (isMarkAllRead && event.detail.success) {
      // "Mark all as read" covers chat notifications too — they are ordinary
      // notifications that happen to feed a second badge.
      this.applyUnreadCount(0);
      this.applyChatUnreadCount(0);
    }
  }

  handleUnreadCountUpdated(event) {
    this.applyUnreadCount(event.detail?.count);

    // Undefined means the emitter had nothing to say about chat — leave the
    // server-rendered number alone rather than blanking it to zero.
    if (event.detail?.chatCount !== undefined) {
      this.applyChatUnreadCount(event.detail.chatCount);
    }
  }

  applyUnreadCount(count) {
    if (!this.hasBadgeTarget) {
      return;
    }

    applyCountToBadge(this.badgeTarget, count);
  }

  applyChatUnreadCount(count) {
    if (!this.hasChatBadgeTarget) {
      return;
    }

    applyCountToBadge(this.chatBadgeTarget, count);
  }
}
